<template>
  <div class="reminder">
    <div class="logo"></div>
    <van-form
      @submit="onSubmit"
      class="form"
    >
      <van-field
        class="dis-item"
        name="personName"
        label="姓名:"
        v-model="formValue.personName"
        disabled
      />
      <van-field
        class="dis-item"
        name="personName"
        label="工号:"
        v-model="formValue.personCode"
        disabled
      >
      </van-field>
      <van-field
        name="quit"
        label="是否离职:"
        v-model="formValue.empStatus"
        class="form-item"
        :rules="rules.quit"
        :disabled="!isNew"
      >
        <template #input>
          <van-radio-group
            v-model="formValue.empStatus"
            direction="horizontal"
            :disabled="!isNew"
          >
            <van-radio name="0">在职</van-radio>
            <van-radio name="1">离职</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="message"
        v-model="formValue.reason"
        rows="3"
        autosize
        label="原因:"
        type="textarea"
        maxlength="256"
        placeholder="请输入原因"
        show-word-limit
        class="form-item textarea"
        :rules="rules.message"
        :disabled="!isNew"
      />
      <div
        style="margin: 16px;"
        v-if="isNew"
      >
        <van-button
          class="button"
          round
          block
          type="info"
          native-type="submit"
        >提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import { getDataInfo, submitWarningInfo } from '../api/reminder';
import {
  Form,
  Field,
  RadioGroup,
  Radio,
  Button,
  Toast
} from 'vant';
Vue.use(Form).use(Field).use(RadioGroup).use(Radio).use(Button).use(Toast);

export default {
  data() {
    return {
      rules: {
        quit: [{ required: true, message: '请选择是否离职', trigger: 'onChange' }],
        message: [{ required: true, message: '请填写原因', trigger: 'onChange' }]
      },
      formValue: {
        personName: '', // 姓名
        personCode: '', // 工号
        reason: '', // 原因
        empStatus: '0', // 是否离职
        absenceId: '', // 事件ID
      },
      isNew: true,
    }
  },
  mounted() {
    if (this.$route.query.absenceId) {
      this.formValue.absenceId = this.$route.query.absenceId;
    } else {
      this.$router.replace({
        path: '/',
      });
      return;
    }
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      getDataInfo({ absenceId: this.formValue.absenceId }).then((res) => {
        console.log(res);
        if (res.code === 1) {
          Toast.fail(res.message);
          return;
        }
        if (res.status === 1) {
          this.isNew = false;
          let { personName, personCode, reason, empStatus, absenceId } = res;
          this.formValue = {
            personName,
            personCode,
            reason,
            empStatus: empStatus === 0 ? '0' : '1',
            absenceId
          }
          console.log(this.formValue);
        } else {
          this.isNew = true;
          this.formValue.personName = res.personName;
          this.formValue.personCode = res.personCode;
        }
      }
      ).catch((err) => {
        Toast.fail(err);
      });
    },

    onSubmit() {
      if (!this.formValue.personName) {
        Toast.fail('姓名不能为空');
        return
      }
      if (!this.formValue.personCode) {
        Toast.fail('工号不能为空');
        return;
      }
      if (!this.formValue.reason) {
        Toast.fail('原因不能为空');
        return;
      }
      if (!this.formValue.empStatus) {
        Toast.fail('请选择是否离职');
        return;
      }
      if (!this.formValue.absenceId) {
        Toast.fail('事件ID不能为空');
        return;
      }

      let params = {};
      params.absenceId = this.formValue.absenceId;
      params.empStatus = +this.formValue.empStatus;
      params.reason = this.formValue.reason;
      submitWarningInfo(params).then((res) => {
        if (res.status === 1) {
          Toast.success('提交成功');
          this.isNew = false;
          setTimeout(() => {
            location.reload();
          }, 2000);
        }
      }).catch((err) => {
        Toast.fail(err);
      });
    },
  }
};
</script>

<style lang="scss">
.reminder {
  margin: 0 50px;

  .logo {
    height: 200px;
    background: url(https://web-data.zmlearn.com/image/9Prb7NjdqXG33muLfMpQHn/logologin.png) no-repeat center bottom;
    background-size: auto 100px;
    margin-bottom: 80px;
  }

  .dis-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 25px;
  }

  .textarea .van-field__body {
    border: 1px solid #cbcccf;
  }

  .form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;

    .van-field__value {
      margin-top: 20px;
      font-size: 16px;
    }

    .van-cell__title {
      font-size: 16px;
    }

    .van-field__control {
      padding-left: 5px;
      color: #333;
      font-size: 15px;
    }

    .van-field__control::-webkit-input-placeholder {
      color: #ccc;
    }

    .van-field {
      padding: 10px 0;
      border-bottom: 0.5px solid #cbcccf;
    }
  }

  .button {
    width: 100%;
    background: #f32735;
    color: #fff;
    font-size: 34px;
    border: 1px solid #f32735;
  }
}
</style>